export function view(value) {
  return value ? 'Complete' : 'ProgressBar'
}
